import RosterItem from './RosterItem';

export default class RosterBooking extends RosterItem {
  constructor(start, end, hasActuals, fullBookingStart, fullBookingEnd, booking) {
    super('resourcebooking', start, end, hasActuals);
    this.booking = booking;
    this.fullBookingStart = fullBookingStart;
    this.fullBookingEnd = fullBookingEnd;
  }
}
